"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/portal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalAccountService = void 0;
const portal_service_pb_1 = require("./portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.account.v1.PortalAccountService
 */
exports.PortalAccountService = {
    typeName: "spwn.account.v1.PortalAccountService",
    methods: {
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.RegisterUser
         */
        registerUser: {
            name: "RegisterUser",
            I: portal_service_pb_1.PortalAccountServiceRegisterUserRequest,
            O: portal_service_pb_1.PortalAccountServiceRegisterUserResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.UpdateUser
         */
        updateUser: {
            name: "UpdateUser",
            I: portal_service_pb_1.PortalAccountServiceUpdateUserRequest,
            O: portal_service_pb_1.PortalAccountServiceUpdateUserResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetMe
         */
        getMe: {
            name: "GetMe",
            I: portal_service_pb_1.PortalAccountServiceGetMeRequest,
            O: portal_service_pb_1.PortalAccountServiceGetMeResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetFanByFirestoreId
         */
        getFanByFirestoreId: {
            name: "GetFanByFirestoreId",
            I: portal_service_pb_1.PortalAccountServiceGetFanByFirestoreIdRequest,
            O: portal_service_pb_1.PortalAccountServiceGetFanByFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetFanByEmail
         */
        getFanByEmail: {
            name: "GetFanByEmail",
            I: portal_service_pb_1.PortalAccountServiceGetFanByEmailRequest,
            O: portal_service_pb_1.PortalAccountServiceGetFanByEmailResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetBrandById
         */
        getBrandById: {
            name: "GetBrandById",
            I: portal_service_pb_1.PortalAccountServiceGetBrandByIdRequest,
            O: portal_service_pb_1.PortalAccountServiceGetBrandByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetBrandByFirestoreId
         */
        getBrandByFirestoreId: {
            name: "GetBrandByFirestoreId",
            I: portal_service_pb_1.PortalAccountServiceGetBrandByFirestoreIdRequest,
            O: portal_service_pb_1.PortalAccountServiceGetBrandByFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetTenantByFirestoreId
         */
        getTenantByFirestoreId: {
            name: "GetTenantByFirestoreId",
            I: portal_service_pb_1.PortalAccountServiceGetTenantByFirestoreIdRequest,
            O: portal_service_pb_1.PortalAccountServiceGetTenantByFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetDMAccounts
         */
        getDMAccounts: {
            name: "GetDMAccounts",
            I: portal_service_pb_1.PortalAccountServiceGetDMAccountsRequest,
            O: portal_service_pb_1.PortalAccountServiceGetDMAccountsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetCoreFanByBrandIdAndUserId
         */
        getCoreFanByBrandIdAndUserId: {
            name: "GetCoreFanByBrandIdAndUserId",
            I: portal_service_pb_1.PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest,
            O: portal_service_pb_1.PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.SaveUserMemo
         */
        saveUserMemo: {
            name: "SaveUserMemo",
            I: portal_service_pb_1.PortalAccountServiceSaveUserMemoRequest,
            O: portal_service_pb_1.PortalAccountServiceSaveUserMemoResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.Idempotent,
        },
        /**
         * @generated from rpc spwn.account.v1.PortalAccountService.GetCoreFanBrandFirestoreIdsByUserId
         */
        getCoreFanBrandFirestoreIdsByUserId: {
            name: "GetCoreFanBrandFirestoreIdsByUserId",
            I: portal_service_pb_1.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest,
            O: portal_service_pb_1.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.Idempotent,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map